import React from "react";
import { Kpi, LineChart33, PictureWall, Pies3 } from "./charts";

export const Campaign = () => (
  <svg viewBox="0 0 108 136">
    <Kpi x={8} y={8} />
    <Kpi x={40} y={8} />
    <Kpi x={72} y={8} />

    <LineChart33 x={8} y={28} />

    <PictureWall x={8} y={60} />

    <Pies3 x={8} y={94} />

    <Kpi x={8} y={126} />
    <Kpi x={40} y={126} />
    <Kpi x={72} y={126} />
  </svg>
);
